export const locationRowStyles = {
  btnDetails: {
    border: '1px solid #9f9f9f',
    color: '#737373'
  }
}
